module.exports = __webpack_public_path__ + "static/img/sao.83ba507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sureOrder/sao.png
// module id = ngeB
// module chunks = 55